class Serve {
  _serve = {};

  addServeObject(serve) {
    this._serve = structuredClone(serve);
  }

  get(key) {
    return this._serve[key];
  }

  get runtimes() {
    return this._serve.runtimes || {};
  }
}

const serve = new Serve();
export { Serve, serve };